/**
 * Mixin компонентов списка пользователей
 */

export default {
    props: {
        allowRemove: {
            type: Boolean,
            default: false,
        },
        allowSelect: {
            type: Boolean,
            default: false,
        },
        vuexState: String,
    }
};
